export const chatDashboardSystemMessage = {
  adminTakeover: 'Chat Diambil Alih oleh Admin',
};
